import { Outlet } from "remix";
import { BreadcrumbLink } from "~/components/Breadcrumbs";

export const handle = {
  breadcrumb: ({ params }: { params: Record<string, string> }) => (
    <BreadcrumbLink to={`/${params.festivalSlug}/info-staende`}>
      Infostände
    </BreadcrumbLink>
  ),
};

export default function DigitaleStaende() {
  return <Outlet />;
}
